import cn from 'classnames';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { Text } from '@/shared/ui/core';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef, ReactNode, useId } from 'react';
import styles from './switch.module.scss';


export interface SwitchProps
    extends ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> {
    label?: ReactNode;
    description?: ReactNode;
    error?: ReactNode;
    wrapperClassName?: string;
    labelPosition?: 'left' | 'right';
}


type LabelProps = {
    id: string;
    label?: ReactNode;
}


const Label = ({ label, id }: LabelProps) => (
    <Text
        as="label"
        size="lg"
        tone="primary"
        weight="medium"
        lineHeight={ 1 }
        htmlFor={ id }
    >
        { label }
    </Text>
);


export const Switch = forwardRef<ComponentRef<typeof SwitchPrimitive.Root>, SwitchProps>(function Switch ({
    className,
    wrapperClassName,
    label,
    disabled,
    labelPosition = 'right',
    id,
    ...props
}, ref) {
    const _id = useId();

    return (
        <div className={ cn(styles.wrapper, wrapperClassName) }>
            {
                labelPosition === 'left' &&
                label &&
                <Label
                    label={ label }
                    id={ id ?? _id }
                />
            }

            <SwitchPrimitive.Root
                ref={ ref }
                disabled={ disabled }
                className={ cn(styles.root, className) }
                { ...props }
                id={ id ?? _id }
            >
                <SwitchPrimitive.Thumb className={ styles.thumb }/>
            </SwitchPrimitive.Root>

            {
                labelPosition === 'right' &&
                label &&
                <Label
                    label={ label }
                    id={ id ?? _id }
                />
            }
        </div>
    );
});
